import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";
import AppShell from "@/components/layout/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Pipeline from "@/pages/Pipeline";
import Quotations from "@/pages/Quotations";
import Invoices from "@/pages/Invoices";
import Payments from "@/pages/Payments";
import ServiceOps from "@/pages/ServiceOps";
import Support from "@/pages/Support";
import Team from "@/pages/Team";
import WarRoom from "@/pages/WarRoom";
import Automation from "@/pages/Automation";
import Analytics from "@/pages/Analytics";
import AIAssistant from "@/pages/AIAssistant";
import Settings from "@/pages/Settings";
import Routing from "@/pages/Routing";
import Customers from "@/pages/Customers";
import TeamChat from "@/pages/TeamChat";
import Integrations from "@/pages/Integrations";
import PaymentReturn from "@/pages/PaymentReturn";
import PortalLogin from "@/pages/portal/PortalLogin";
import Portal from "@/pages/portal/Portal";

function FullScreenLoader() {
  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <LogoMark className="h-12 w-12 animate-pulse" />
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/signup" element={<PublicOnly><Signup /></PublicOnly>} />
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/payment/success" element={<PaymentReturn mode="success" />} />
          <Route path="/payment/cancel" element={<PaymentReturn mode="cancel" />} />
          <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="crm" element={<Leads />} />
            <Route path="sales" element={<Pipeline />} />
            <Route path="routing" element={<Routing />} />
            <Route path="quotations" element={<Quotations />} />
            <Route path="billing" element={<Invoices />} />
            <Route path="payments" element={<Payments />} />
            <Route path="service" element={<ServiceOps />} />
            <Route path="support" element={<Support />} />
            <Route path="customers" element={<Customers />} />
            <Route path="team" element={<Team />} />
            <Route path="chat" element={<TeamChat />} />
            <Route path="war-room" element={<WarRoom />} />
            <Route path="automation" element={<Automation />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="ai" element={<AIAssistant />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
